import React, { useRef, useEffect } from 'react';

import { useLayoutContext } from '@ott/layout-context';

import { S3_IMAGES_URL } from '../../../../constants';

import { motion, useInView, useAnimation } from 'framer-motion';

type Props = { className?: string };

const OrbitTwo = ({ className }: Props) => {
  const ref = useRef(null);
  const inViewport = useInView(ref);
  const control = useAnimation();
  const { isDesktop } = useLayoutContext();

  const variants = {
    initial: isDesktop
      ? { opacity: 0, scale: 0 }
      : { opacity: 0, scale: 0, left: '50%', right: '50%', x: '-50%', y: '-3%' },
    animate: isDesktop
      ? {
          opacity: 0.7,
          scale: 1,
          transition: { duration: 0.85 },
        }
      : {
          opacity: 0.7,
          scale: 0.7,
          rotate: 15,
          transition: { duration: 0.85 },
        },
  };

  useEffect(() => {
    if (inViewport) {
      control.start('animate');
    }
  }, [control, inViewport, isDesktop]);

  return (
    <motion.svg
      ref={ref}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="834"
      height="353"
      fill="none"
      variants={variants}
      initial="initial"
      animate={control}
    >
      <path
        id="orbitThree"
        stroke="url(#a)"
        strokeWidth="2"
        shapeRendering="geometricPrecision"
        d="M831.396 287.664c-4.986 18.609-21.236 33.341-46.537 43.998-25.293 10.654-59.548 17.195-100.366 19.469-81.631 4.549-189.395-7.977-303.936-38.668-114.541-30.691-214.13-73.726-282.55-118.48-34.213-22.379-60.607-45.171-77.185-67.044-16.583-21.88-23.29-42.763-18.303-61.372 4.986-18.61 21.235-33.341 46.536-43.998C74.35 10.915 108.603 4.374 149.422 2.099c81.63-4.548 189.395 7.977 303.936 38.668 114.54 30.691 214.13 73.727 282.55 118.481 34.212 22.379 60.607 45.171 77.185 67.044 16.583 21.88 23.289 42.763 18.303 61.372Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="752.404"
          x2="162.797"
          y1="25.922"
          y2="331.088"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EED7F1" />
          <stop offset=".085" stopColor="#FEFCFE" />
          <stop offset=".192" stopColor="#DBC1D4" />
          <stop offset=".285" stopColor="#6DD2E5" />
          <stop offset=".4" stopColor="#7BA0EB" />
          <stop offset=".51" stopColor="#BC86F6" />
          <stop offset=".632" stopColor="#DCC4F8" />
          <stop offset=".747" stopColor="#BFB5C6" />
          <stop offset=".87" stopColor="#F5F4F6" />
          <stop offset="1" stopColor="#D7CACE" />
        </linearGradient>
      </defs>
      <image
        href={`${S3_IMAGES_URL}planets_for_orbits/planet-3@2x.png`}
        width="50"
        height="50"
        x={isDesktop ? 740 : 420}
        y={isDesktop ? 160 : 300}
      >
        <mpath href="#orbitThree" />
      </image>
    </motion.svg>
  );
};

export default OrbitTwo;
